export enum ButtonVariant {
  Contained = 'contained',
  Outlined = 'outlined',
}

export default ButtonVariant;
